<div class="sidecontent-option-container" [ngSwitch]="displayedContent" >
  <mat-toolbar class="sidemenu-toolbar p-0 gap-0">
    <button mat-icon-button class="example-icon" (click)="onBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span *ngIf="displayedContent == 'promtStatus'" class="title">{{ 'Status' | titlecase }}</span>
    <ng-container *ngIf="displayedContent == 'addComponent'" >
    <span class="title">{{ 'Add Component' | titlecase}}</span>
  </ng-container>
  <ng-container *ngIf="displayedContent == 'modifyPage'">
    <span class="title">{{ 'Modify Page' | titlecase}}</span>
  </ng-container>
  <ng-container *ngIf="displayedContent == 'widget'">
    <span class="title">{{ selectedWidgetMetaData?.widgetLabel+ " " + "Properties" || 'widget' | titlecase }}</span>
  </ng-container>
  <ng-container *ngIf="displayedContent == sideNavContentOptions.menu">
    <span class="title">{{   "Menu Properties" | titlecase }}</span>
  </ng-container>
  <ng-container *ngIf="displayedContent == sideNavContentOptions.nav">
    <span class="title">{{   "Navbar Properties" | titlecase }}</span>
  </ng-container>
  </mat-toolbar>

  <div class="scroll-container">

    <ng-container *ngSwitchCase="sideNavContentOptions.addComponent">
      <mat-form-field class="w-100 rounded-0 mat-no-hint">
        <mat-label>Search Component</mat-label>
        <input matInput type="text" [(ngModel)]="searchTerm" (ngModelChange)="applyFilter()">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      <mat-accordion displayMode="flat" togglePosition="before" [multi]="isFilterApplied">
        <mat-expansion-panel *ngFor="let category of filteredCategories; let i = index" [expanded]="panelStates[i]">
          <mat-expansion-panel-header>
            <mat-panel-title class="m-0">
              <span class="flex-fill">{{category.type}}</span>
              <mat-chip>{{category.items.length}}</mat-chip>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row g-2">
            <div class="col-4" *ngFor="let item of category.items">
              <div ngxGridsterItemPrototype [config]="{helper: true}"
              [w]="1" [h]="1"
              [wSm]="1" [hSm]="1"
              [wMd]="2" [hMd]="1"
              [wLg]="2" [hLg]="2"
              [wXl]="3" [hXl]="2"
              (drop)="addWidgetFromDrag( $event,item)"
              (enter)="over($event)"
              (out)="out($event)"
              class="gridster-item-prototype">
                <mat-card class="mat-custom-card-sm mat-card-component">
                  <mat-card-content class="p-1">
                    <div class="name">{{ item.name | titlecase}}</div>
                    <div class="icon">
                      <img [src]="getImageUrl(item)" [alt]="item.image + 'image'">
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
          
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>

    <ng-container *ngSwitchCase="sideNavContentOptions.modifyPage">
      <mat-form-field class="w-100 rounded-0">
        <mat-label>Search Template</mat-label>
        <input matInput type="text" [(ngModel)]="searchTerm" (ngModelChange)="applyFilter()">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      <mat-accordion displayMode="flat" togglePosition="before" [multi]="isFilterApplied">
        <mat-expansion-panel *ngFor="let category of filteredDefaultPageTemplate; let i = index" [expanded]="panelStates[i]">
          <mat-expansion-panel-header>
            <mat-panel-title class="m-0">
              <span *ngIf="category.pageType.trim() === pageTypes.loginPage" class="flex-fill">{{ 'Login' | titlecase}}</span>
              <span *ngIf="category.pageType.trim() === pageTypes.forgetPassword" class="flex-fill">{{ 'Forgot Password' | titlecase}}</span>
              <span *ngIf="category.pageType.trim() === pageTypes.changePassword" class="flex-fill">{{ 'Change Password' | titlecase}}</span>
              <mat-chip>{{category.items.length}}</mat-chip>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row g-2">
            <div class="col-6" *ngFor="let item of category.items">
              <mat-card class="mat-custom-card-sm mat-card-component" draggable="true"
                (dragstart)="onDragStart($event,item)" >
                <mat-card-content>
                  <div class="name">{{ item.masterPageName | titlecase}}</div>
                  <div class="icon">
                    <img [src]="getPageImageUrl(item)" [alt]="item.icon + 'image'">
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    
    </ng-container>
    <ng-container *ngSwitchCase="sideNavContentOptions.widget">
      <lib-web-widget-property-forms></lib-web-widget-property-forms>  
    </ng-container>
    <ng-container *ngSwitchCase="sideNavContentOptions.menu">
      <form [formGroup]="menuButtonGroup"  (ngSubmit)="onSubmit(menuButtonGroup)">
        <mat-accordion displayMode="flat" togglePosition="before">
          <div class="toggle-container custom-toggle-container m-2" >
            <mat-slide-toggle (change)="toggleMenu()" >
              <span >Toggle Side Nav</span>
            </mat-slide-toggle>
          </div>
          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              Pages
            </mat-expansion-panel-header>
            <div formArrayName="pages" class="d-flex flex-column gap-2 mb-2">
              <ng-container  *ngFor="let item of pages.controls;let pageIndex = index">
              <div class="toggle-container custom-toggle-container" [formGroupName]="pageIndex">
                <mat-slide-toggle formControlName="enable" >
                  <span >{{item.get('name')?.value}}</span>
                </mat-slide-toggle>
              </div>
            </ng-container>
            </div>
           
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              User & Logout
            </mat-expansion-panel-header>
            <div class="toggle-container custom-toggle-container" >
              <mat-slide-toggle labelPosition="before" formControlName="userInfo">UserInfo</mat-slide-toggle>
            </div>

            <div class="toggle-container custom-toggle-container mt-2" >
              <mat-slide-toggle labelPosition="before" formControlName="logoutOption">Logout Option</mat-slide-toggle>
            </div>

          </mat-expansion-panel>
        </mat-accordion>
        <div class="p-3">
          <button mat-stroked-button color="primary" class="add-button w-100" type="submit">Update Component</button>
        </div>
      </form>
      
    </ng-container>
    <ng-container *ngSwitchCase="sideNavContentOptions.nav">
      <form [formGroup]="navButtonGroup"  (ngSubmit)="onSubmit(navButtonGroup)">
        <mat-accordion displayMode="flat" togglePosition="before">            
            <div class="ps-4 mat-form-field-container">
              <mat-label>Selecte an Option</mat-label>
              <mat-radio-group aria-label="Select an option" formControlName="selectedOption" >
                <mat-radio-button value="logo">Logo</mat-radio-button>
                <mat-radio-button value="title">Title</mat-radio-button>
              </mat-radio-group>

              <div class="image-upload m-4" style="margin-top: 15px" *ngIf="navButtonGroup.get('selectedOption')?.value == 'logo'" matRipple (click)="fileInput.click()">
                <label for="logo">select logo</label>
                <input #fileInput id="logo" type="file" (change)="onFileSelected($event)" style="display: none" />
                <img [src]="
                    getImageFile(navConfig?.logo)
                  " class="w-100" alt="logo" />
                <div class="edit-icon">
                  <mat-icon>edit</mat-icon>
                </div>
              </div>

              <mat-form-field class="w-100 pe-2 mt-1" appearance="outline" *ngIf="navButtonGroup.get('selectedOption')?.value == 'title'">
                <mat-label>Title</mat-label>
                <input type="text" matInput formControlName="title">
              </mat-form-field>
      
            </div>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              Pages
            </mat-expansion-panel-header>
            <div formArrayName="pages" class="d-flex flex-column gap-2 mb-2">
              <ng-container  *ngFor="let item of navPages.controls;let pageIndex = index">
              <div class="toggle-container custom-toggle-container" [formGroupName]="pageIndex">
                <mat-slide-toggle formControlName="enable" >
                  <span >{{item.get('name')?.value}}</span>
                </mat-slide-toggle>
              </div>
            </ng-container>
            </div>
           
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              User & Logout
            </mat-expansion-panel-header>
            <div class="toggle-container custom-toggle-container" >
              <mat-slide-toggle labelPosition="before" formControlName="userInfo">UserInfo</mat-slide-toggle>
            </div>

            <div class="toggle-container custom-toggle-container mt-2" >
              <mat-slide-toggle labelPosition="before" formControlName="logoutOption">Logout Option</mat-slide-toggle>
            </div>

          </mat-expansion-panel>
        </mat-accordion>
        <div class="p-3">
          <button mat-stroked-button color="primary" class="add-button w-100" type="submit">Update Component</button>
        </div>
      </form>
      
    </ng-container>
    <ng-container *ngSwitchCase="sideNavContentOptions.promtStatus" >
      <div class="disabled-message">
        Component disabled. Please enable the component to view properties.
      </div>
    </ng-container>
  </div>
  </div>
  